<app-pop-up
	[id]="popUpId"
	[options]="{}"
>
	<div class="popup popup-biometrics-registration-error">
		<app-loader
			#loaderStep1
			[context]="'element'"
			[isActive]="false"
		></app-loader>
		<button
			class="button-reset close"
			type="button"
			(click)="close()"
		></button>

		@if (templateData) {
			<div class="popup__content popup-biometrics-registration-error__content">
				<h3 class="popup__header">
					{{ title }}
				</h3>
				<div class="popup__body">
					<message
						[isAdaptive]="true"
						[titleFail]="templateData.titleText"
						[mode]="'fail'"
					>
						@if (templateData.messageText) {
							<div resultText>
								{{ templateData.messageText }}
							</div>
						}
					</message>
				</div>
				<div class="popup__footer popup-biometrics-registration-error__footer">
					@if (templateData.actionButton) {
						<button
							class="button"
							type="button"
							(click)="templateData.actionButton.action()"
						>
							{{ templateData.actionButton.title }}
						</button>
					}
					<button
						class="button button--white"
						type="button"
						(click)="close()"
					>
						Отменить
					</button>
				</div>
			</div>
		}
	</div>
</app-pop-up>
